import { formatter } from '../../tools/formatter';

const VALID_REGEX = /[^a-zA-Z0-9-&._ ]+/g;

export const parseProviders = (data) => {
  const userInformation = { userRoles: data.userRoles };

  if (data.providerOrg?.length > 0) {
    const providers = data.providerOrg
      .sort((a, b) => a.lastName?.localeCompare(b.lastName))
      .map((provider) => {
        let providerName;
        const fName =
          provider.firstName &&
          provider.firstName.replace(VALID_REGEX, '').trim();
        const lName =
          provider.lastName &&
          provider.lastName.replace(VALID_REGEX, '').trim();
        if (provider.firstName) {
          const firstName = formatter('name', fName);
          const lastName = formatter('name', lName);
          providerName = `${lastName}, ${firstName}`;
        } else {
          providerName = formatter('name', lName);
        }
        return {
          ...provider,
          ...(fName && { firstName: fName }),
          ...(lName && { lastName: lName }),
          isThirdParty: !provider.registeredOrg,
          label: `${providerName} (${provider.corpMpin})`,
          mpin: provider.corpMpin,
          name: providerName,
          registeredOrg: provider.registeredOrg,
          userId: provider.id,
        };
      });

    userInformation.corporates = [...new Set(providers)];
    return userInformation;
  }

  return userInformation;
};
